<div class="main-box noBorder" *transloco="let t; prefix: 'fuelDashboard'">
    <div class="inner-body">
        <div class="card grap-card increase no-border">
            <div class="card-body p-0">
                <div class="grap-up d-flex align-items-center justify-content-between">
                    <div class="graph-text">
                        <h4>{{ t('modals.fillUpFrequencyVolume.title') }}</h4>
                        <p>
                            {{ headline.value }} <strong>{{ headline.change }}</strong>
                            <i><img src="assets/images-fuel/downArrowOrnageIcon.svg" alt=""></i>
                        </p>
                    </div>
                    <div class="tab-main">
                        <ul>
                            <li><button [class.active]="viewMode() == 'all'" (click)="viewMode.set('all')">{{ t('viewModes.all') }}</button>
                            </li>
                            <li><button [class.active]="viewMode() == 'fillUp'"
                                    (click)="viewMode.set('fillUp')">{{ t('viewModes.fillUps') }}</button></li>
                            <li><button [class.active]="viewMode() == 'totalVolume'"
                                    (click)="viewMode.set('totalVolume')">{{ t('viewModes.totalVolume') }}</button></li>
                            <li><button [class.active]="viewMode() == 'avgVolume'"
                                    (click)="viewMode.set('avgVolume')">{{ t('viewModes.avgFillVolume') }}</button></li>
                        </ul>
                    </div>
                    <div class="wrapper_allBtnWrapper">
                        <div class="common-filter common-dropdown-checkbox">
                            <div class="common-drop-down dropdown">
                                <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton1"
                                    data-bs-toggle="dropdown" aria-expanded="false">
                                    {{ t('filters.filterByMakeAndModel') }}
                                    <img src="/assets/images-fuel/filterDrpDwnIcon.svg" alt="">
                                </button>

                                <ul class="dropdown-menu large-menu dropdown-menu-end checkbox_wrap"
                                    aria-labelledby="dropdownMenuButton1" (click)="buttonMenuClick($event)">

                                    <li>
                                        <div>
                                            <label class="parent_chk_box">
                                                <input type="checkbox" id="parent-task" />
                                                <span>{{ t('locations.southAfrica') }}</span>
                                            </label>
                                            <div class="task-group">
                                                <label>
                                                    <input type="checkbox" id="child-task-1" />
                                                    <span>{{ t('locations.johannesburg') }}</span>
                                                </label>
                                                <label>
                                                    <input type="checkbox" id="child-task-2" />
                                                    <span>{{ t('locations.polokwane') }}</span>
                                                </label>
                                                <label>
                                                    <input type="checkbox" id="child-task-3" />
                                                    <span>{{ t('locations.gqeberha') }}</span>
                                                </label>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div>
                                            <label class="parent_chk_box">
                                                <input type="checkbox" id="parent-task" />
                                                <span>{{ t('locations.zambia') }}</span>
                                            </label>
                                            <div class="task-group">
                                                <label>
                                                    <input type="checkbox" id="child-task-1" />
                                                    <span>{{ t('locations.lusaka') }}</span>
                                                </label>
                                                <label>
                                                    <input type="checkbox" id="child-task-2" />
                                                    <span>{{ t('locations.chingola') }}</span>
                                                </label>
                                                <label>
                                                    <input type="checkbox" id="child-task-3" />
                                                    <span>{{ t('locations.kasama') }}</span>
                                                </label>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div>
                                            <label class="parent_chk_box">
                                                <input type="checkbox" id="parent-task" />
                                                <span>{{ t('locations.mozambique') }}</span>
                                            </label>
                                            <div class="task-group">
                                                <label>
                                                    <input type="checkbox" id="child-task-1" />
                                                    <span>{{ t('locations.maputo') }}</span>
                                                </label>
                                                <label>
                                                    <input type="checkbox" id="child-task-2" />
                                                    <span>{{ t('locations.pemba') }}</span>
                                                </label>
                                                <label>
                                                    <input type="checkbox" id="child-task-3" />
                                                    <span>{{ t('locations.nampula') }}</span>
                                                </label>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="common-filter driverFilter common-dropdown-checkbox">
                            <div class="common-drop-down dropdown">
                                <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton1"
                                    data-bs-toggle="dropdown" aria-expanded="false">
                                    {{ t('filters.filterByDrivers') }}
                                    <img src="/assets/images-fuel/filterDrpDwnIcon.svg" alt="">
                                </button>

                                <ul class="dropdown-menu large-menu dropdown-menu-end checkbox_wrap"
                                    aria-labelledby="dropdownMenuButton1" (click)="buttonMenuClick($event)">

                                    <li>
                                        <div>
                                            <label class="parent_chk_box">
                                                <input type="checkbox" id="parent-task" />
                                                <span>{{ t('locations.southAfrica') }}</span>
                                            </label>
                                            <div class="task-group">
                                                <label>
                                                    <input type="checkbox" id="child-task-1" />
                                                    <span>{{ t('locations.johannesburg') }}</span>
                                                </label>
                                                <label>
                                                    <input type="checkbox" id="child-task-2" />
                                                    <span>{{ t('locations.polokwane') }}</span>
                                                </label>
                                                <label>
                                                    <input type="checkbox" id="child-task-3" />
                                                    <span>{{ t('locations.gqeberha') }}</span>
                                                </label>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div>
                                            <label class="parent_chk_box">
                                                <input type="checkbox" id="parent-task" />
                                                <span>{{ t('locations.zambia') }}</span>
                                            </label>
                                            <div class="task-group">
                                                <label>
                                                    <input type="checkbox" id="child-task-1" />
                                                    <span>{{ t('locations.lusaka') }}</span>
                                                </label>
                                                <label>
                                                    <input type="checkbox" id="child-task-2" />
                                                    <span>{{ t('locations.chingola') }}</span>
                                                </label>
                                                <label>
                                                    <input type="checkbox" id="child-task-3" />
                                                    <span>{{ t('locations.kasama') }}</span>
                                                </label>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div>
                                            <label class="parent_chk_box">
                                                <input type="checkbox" id="parent-task" />
                                                <span>{{ t('locations.mozambique') }}</span>
                                            </label>
                                            <div class="task-group">
                                                <label>
                                                    <input type="checkbox" id="child-task-1" />
                                                    <span>{{ t('locations.maputo') }}</span>
                                                </label>
                                                <label>
                                                    <input type="checkbox" id="child-task-2" />
                                                    <span>{{ t('locations.pemba') }}</span>
                                                </label>
                                                <label>
                                                    <input type="checkbox" id="child-task-3" />
                                                    <span>{{ t('locations.nampula') }}</span>
                                                </label>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="common-drop-down selectBox dropdown">
                            <app-date-filter [filter]="utilizationDateFilter" [isButtonIntervalSelector]="false"
                                [disableCustomDateSelector]="false" [defaultInterval]="defaultInterval"
                                (filterChanged)="onUtilizationDateFilterChange($event)">
                            </app-date-filter>
                        </div>

                        <div class="btnWrapper">
                            <div class="common-drop-down noFltr dropdown">
                                <button type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown"
                                    aria-expanded="false">
                                    <img src="assets/images-fuel/threeDotBtnIcon.svg" alt="grapBtnIcon" />
                                </button>
                                <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                    <li><a class="dropdown-item">{{ t('units.litres') }}</a></li>
                                    <li>
                                        <a class="dropdown-item">{{ t('units.litresPerKilometer') }}</a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item">{{ t('units.litresPer100km') }}</a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item">{{ t('units.randsPerLitre') }}</a>
                                    </li>
                                </ul>
                            </div>
                            <button class="closeIcon" (click)="closeModal()">
                                <img src="assets/images-fuel/crossBigIcon.svg" alt="icon-close" />
                            </button>
                        </div>
                    </div>
                </div>
                <div class="grap-down">
                    <div class="line-barchart-big">
                        @defer(on timer(200ms) ){
                        <app-stacked-bar-chart [data]="fillUpFrequencyBigData" [margin]="chartMargin"
                            [viewMode]="viewMode()"></app-stacked-bar-chart>
                        }
                    </div>

                    <div class="exportWrap d-flex align-items-center justify-content-between">
                        <ul class="graphPoint events-graph">
                            <li>{{ t('charts.unusualLoss') }}</li>
                            <li>{{ t('charts.driving') }}</li>
                            <li>{{ t('charts.idlingConsumption') }}</li>
                        </ul>

                        <div class="exportListing">
                            <div class="common-drop-down dropdown">
                                <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton1"
                                    data-bs-toggle="dropdown" aria-expanded="false">
                                    {{ t('export.export') }} <i><img src="./assets/images-fuel/downloadIcon.svg" alt="export-icon" /></i>
                                </button>
                                <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                    <li><a class="dropdown-item">{{ t('export.asPdf') }}</a></li>
                                    <li><a class="dropdown-item">{{ t('export.asCsv') }}</a></li>
                                    <li><a class="dropdown-item">{{ t('export.viaEmail') }}</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>